// extracted by mini-css-extract-plugin
export default {"fullWidth":"_l-z","image":"am-z","lazyLoadPicture":"bm-z","lazyLoadSpinner":"cm-z","lazyLoadSpin":"dm-z","lazyLoadImage":"em-z","hasStyledAspectRatio":"fm-z"};